<div class="cellstyle" [ngbTooltip]="params.value"  [placement]="getTooltipPlacement(params.value)" tooltipClass="custom-tooltip" container="body">
    {{ params.value }}
</div>
